import { PATH } from '@common';

const SYSTEM_ADMIN = 'sa';
const TENANT_ADMIN = 'ta';
const NORMAL = 'na';

// 所有菜单定义
const ALL_MENUS = [
	{
		label: '首页',
		path: PATH.DESK2_HOME,
		vendorPath: PATH.DESK2_HOME_VENDOR,
	},
	{
		label: '保险产品',
		path: PATH.DESK2_PRODUCT_MAIN,
		vendorPath: PATH.DESK2_PRODUCT_MAIN_VENDOR,
	},
	{
		label: '企业精选',
		path: PATH.DESK2_ENTERPRISE_EXCLUSIVE,
		vendorPath: PATH.DESK2_ENTERPRISE_EXCLUSIVE_VENDOR,
	},
	{
		label: '信息披露',
		path: PATH.DESK2_DISCLOSURE_MAIN,
		vendorPath: PATH.DESK2_DISCLOSURE_MAIN_VENDOR,
	},
	{
		label: '关于我们',
		path: PATH.DESK2_ABOUT_US,
		vendorPath: PATH.DESK2_ABOUT_US_VENDOR,
	},
	{
		label: '帮助中心',
		path: PATH.DESK2_HELP,
		vendorPath: PATH.DESK2_HELP_VENDOR,
	}
];
export { SYSTEM_ADMIN, TENANT_ADMIN, NORMAL, ALL_MENUS };
